const itemVariantsApi = {
  CREATE_ITEM_VARIANTS: `/api/restaurant/itemvariant/create`,
  UPDATE_ITEM_VARIANTS: `/api/restaurant/itemvariant/update`,
  DELETE_ITEM_VARIANTS: `/api/restaurant/itemvariant/delete`,
  GET_ITEM_VARIANTS: `/api/restaurant/itemvariant`,
};
export default itemVariantsApi;
